"use client";

import React from "react";
import QuickContact from "@/components/common/QuickContact";
import EventTicker from "@/components/common/EventTicker";
// import GlobalHeader from "@/components/common/newCommonComponent/GlobalHeader";
import GlobalFooter from "@/components/common/newCommonComponent/GlobalFooter";
import ContactBanner from "@/components/newPageComponent/contact/ContactBanner";
import ContactBannerLabel from "@/components/newPageComponent/contact/ContactBannerLabel";
import GlobalPresence from "@/components/newPageComponent/contact/GlobalPresence";
import GlobalHeaderNew from "@/components/common/newCommonComponent/GlobalHeaderNew";

const DesktopPage: React.FC = () => {
  return (
    <main className="w-full bg-white">
      <EventTicker />
      <div className="bg-[#191919] w-full blue_shadow">
        <GlobalHeaderNew />
      </div>
      <ContactBanner />
      <ContactBannerLabel />
      <GlobalPresence />
      <div className="w-full">
        <GlobalFooter />
      </div>
      <QuickContact />
    </main>
  );
};

export default DesktopPage;
